export default __webpack_public_path__ + "static/media/check_box_selected.692eecae.svg";